<template>
  <div class="expand">
    <Select v-model="model" style="width:100px; margin-right: 40px;" placeholder="请选择商品" v-if='row.sku.length>1'>
        <Option v-for="(item,index) in row.sku" :value="item.goods_sku_id" :key="item.goods_sku_id">{{ item.goods_sku_id }}</Option>
    </Select>
    <Input v-model="price" placeholder="请输入价格" style="width: 120px; margin-right: 30px;" />
    <Button style="margin-right: 100px;" @click="changePrice">更改</Button>
    <Input v-model="linePrice" placeholder="请输入划线价格" style="width: 120px; margin-right: 30px;" />
    <Button @click="changeLinePrice">更改</Button>
  </div>
</template>

<script>
import { Button, Input, Select, Option } from "iview";
// import { updateList } from "@/api/listReq";

export default {
  name: 'expand',
 
  components: {
    Button, 
    Input,
    Select,
    Option
  },

  props: {
    row: Object,
    index: Number
  },

  data() {
    return {
      price: '',
      linePrice: '',
      model: null
    }
  },


  methods: {
    changePrice() {
     
      if(!this.price) {
        this.$Message.error("请输入价格!");
        return;
      }
      if(this.row.sku.length>1) {
        if(!this.model) {
          this.$Message.error("请选择商品!");
          return;
        }
        let serialNum = this.row.sku.map((ele,index) => {
          if(ele.goods_sku_id === this.model) {
            return index
          }
        });
        this.$emit( 'clickModelPrice', [ this.model, this.index, this.price, serialNum[0] ] )
        // let arr = [{
        //     goods_sku_id: this.model,
        //     goods_price: this.price,
        //     line_price: this.row.sku[0].line_price,
        //     goods_weight: this.row.sku[0].goods_weight
        // }]
        // updateList(arr).then(res=>{
        //   this.$Message.success("修改成功");
        // })
      }else {
        this.$emit('clickPrice', [this.row.sku[0].goods_sku_id, this.index, this.price])
        // let arr = [{
        //     goods_sku_id: this.row.sku[0].goods_sku_id,
        //     goods_price: this.price,
        //     line_price: this.row.sku[0].line_price,
        //     goods_weight: this.row.sku[0].goods_weight
        // }]
        // updateList(arr).then(res=>{
        //   this.$Message.success("修改成功");
        // })
      }
    },
    changeLinePrice() {
      if(!this.linePrice) {
        this.$Message.error("请输入价格!");
        return;
      }
      if(this.row.sku.length>1) {
        if(!this.model) {
          this.$Message.error("请选择商品!");
          return;
        }
        let serialNum = this.row.sku.map((ele,index) => {
          if(ele.goods_sku_id === this.model) {
            return index
          }
        });
        this.$emit( 'clickModelLinePrice', [ this.model, this.index, this.linePrice, serialNum[0] ] )
       
      }else {
        this.$emit('clickLinePrice', [this.row.sku[0].goods_sku_id, this.index, this.linePrice])        
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.expand{
  text-align: center;
}
</style>
